import httpClient from "./httpClient";

const deleteToken = async (tokenId: string) => {
    const client = await httpClient.getInstance();
    const result = await client.delete(`tokens/${tokenId}`);
    return result.data.success;
}

export default { deleteToken };
